import { ClassesBuilder } from '@utilities';

const classesConfig = {
  progressBar: 'flex gap-1 h-auto rounded-full overflow-hidden mb-4',
  item: 'grow h-2',
  inactiveItem: 'bg-click-grey',
};

export default new ClassesBuilder(classesConfig);
